import React from 'react';
import { useAuth } from '../../../../commons/Auth';
import { formatCurrency } from '../../../../lib/helpers/formatters';

const TotalSignalsSpecialJobsRevenuesRow = ({
  totals = {},
  route = '',
  activeRoute = false,
  truncateTotals = false,
  profileType = '',
}) => {
  const {
    estimateTotals = 0,
    extraShareTotals = 0,
    adminShareTotals = 0,
    earnedAdminShareTotals = 0,
    billableAdminShareTotals = 0,
    iafsTotals = 0,
  } = totals;

  const [{ newIsAdmin }] = useAuth();

  return (
    <tr
      className="summary-tr"
      onClick={() => {
        return activeRoute === true
          ? (window.location.href = `${
              window.location.href.split('?')[0]
            }/${route}`)
          : null;
      }}
    >
      {!truncateTotals && newIsAdmin && <td>-</td>}
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && <td>-</td>}

      {!truncateTotals && <td>-</td>}
      {!truncateTotals && newIsAdmin && <td>-</td>}
      {!truncateTotals && newIsAdmin && <td>-</td>}
      {!truncateTotals && <td>-</td>}
      <td className="txt-table-right">{formatCurrency(adminShareTotals)}</td>
      <td className="txt-table-right">
        {formatCurrency(earnedAdminShareTotals)}
      </td>
      <td className="txt-table-right">
        {formatCurrency(billableAdminShareTotals)}
      </td>
      <td className="txt-table-right">{formatCurrency(iafsTotals)}</td>

      {!truncateTotals && <td>-</td>}
      {!truncateTotals && <td>-</td>}
    </tr>
  );
};

export default TotalSignalsSpecialJobsRevenuesRow;
